import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import WishListProduct from './WishListProduct';
import loadinggif from '../../Assets/images/loading.gif'

export default function WishList() {
  const [cartId, setcartID] = useState()
  const [Isloading, setIsloading] = useState(false)
  const [Wishlist, setWishlist] = useState({})

  async function RemoveProductWish(productId) {
        await axios.delete('https://ecommerce.routemisr.com/api/v1/wishlist/' + productId, { headers: { token: localStorage.getItem('token') } })
        GetLoggedUserWishList()
  }

  async function GetLoggedUserWishList() {
      setIsloading(true)
      const { data } = await axios.get('https://ecommerce.routemisr.com/api/v1/wishlist', {
        headers: {
          token: localStorage.getItem('token')
        }
      }

      )
      console.log(data)
      setWishlist(data)
      setIsloading(false)
    
  }

  useEffect(() => {
    GetLoggedUserWishList()
  }, [])

  return <>
     <div className="container">
     {Isloading ?  
        <div className='d-flex align-items-center justify-content-center my-5 py-5 text-center loader-row '>
        <div className="col-auto">
        <div className ="preloader">
	<svg className ="cart" role="img" aria-label="Shopping cart line animation" viewBox="0 0 128 128" width="128px" height="128px" xmlns="http://www.w3.org/2000/svg">
		<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="8">
			<g className ="cart__track" stroke="hsla(0,10%,10%,0.1)">
				<polyline points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80" />
				<circle cx="43" cy="111" r="13" />
				<circle cx="102" cy="111" r="13" />
			</g>
			<g className ="cart__lines" stroke="currentColor">
				<polyline className ="cart__top" points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80" stroke-dasharray="338 338" stroke-dashoffset="-338" />
				<g className ="cart__wheel1" transform="rotate(-90,43,111)">
					<circle className ="cart__wheel-stroke" cx="43" cy="111" r="13" stroke-dasharray="81.68 81.68" stroke-dashoffset="81.68" />
				</g>
				<g className ="cart__wheel2" transform="rotate(90,102,111)">
					<circle className ="cart__wheel-stroke" cx="102" cy="111" r="13" stroke-dasharray="81.68 81.68" stroke-dashoffset="81.68" />
				</g>
			</g>
		</g>
	</svg>
</div>

        </div>
      </div> 
     :
    <div>
      {Wishlist?.data?.length == 0 ? <h2 className='a text-center my-5 wishlist py-5'>your wish list is empty</h2> :
        <div className='my-5'>
          {Wishlist.data?.map((Wishproduct, index) => {
            return <>
              <WishListProduct key={index} Wishproduct={Wishproduct} RemoveProductWish={RemoveProductWish}  />

            </>

          })}


        </div>
      }
    </div>}

     </div>


  </>
}
